import * as jsxRuntime from "/home/idra/actions-runner/gis-gjilan-fe/_work/gis-gjilan-fe/gis-gjilan-fe/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment